import { extendedSinglePropertyLookupTypeGuard, singlePropertyLookupTypeGuard } from './ResolutionSchemaDefinition.js';
import { engineUtils } from '../services/EngineUtils.js';
import { VariationOrderGenerator } from './VariationOrderGenerator.js';
export class ExplicitResolutionStrategy {
    constructor(lookup, resolutionSchema, reference) {
        this.lookup = lookup;
        this.resolutionSchema = resolutionSchema;
        this.reference = reference;
    }
    *orderOptionValues(model, optionsPotentialValues) {
        if (!this.lookup.variation.length) {
            const entries = Array.from(optionsPotentialValues);
            yield entries;
            return;
        }
        const options = this.getVariationOptions();
        const optionCompatibleVariation = this.variantsWithOptions(this.lookup.variation, options);
        const variants = new VariationOrderGenerator(optionCompatibleVariation).getVariation();
        this.buildReferenceIdenticalGroups(options, optionsPotentialValues);
        const allIdentical = this.prepareResult(optionsPotentialValues);
        yield allIdentical;
        for (let variation of variants) {
            const result = this.prepareResult(optionsPotentialValues);
            const schema = this.buildOptionPropertiesSchema(variation);
            for (const { option, properties } of schema) {
                const optionValuesCandidates = optionsPotentialValues.get(option);
                const optionReference = this.reference.get(option);
                const optionValues = this.referenceEqualsExceptProperties(optionValuesCandidates, properties, optionReference);
                this.replaceOptionGroup(result, option, optionValues);
            }
            yield result;
        }
    }
    buildReferenceIdenticalGroups(options, optionsPotentialValues) {
        var _a;
        this.referenceIdentical = new Map();
        for (const option of options) {
            const reference = this.reference.get(option);
            const keys = Object.keys(reference);
            const optionValues = (_a = optionsPotentialValues.get(option)) !== null && _a !== void 0 ? _a : [];
            const referenceIdentical = optionValues.filter(o => keys.every(key => engineUtils.equals(engineUtils.getPropertyPathValue(o.model, key), reference[key])));
            this.referenceIdentical.set(option, referenceIdentical);
        }
    }
    prepareResult(optionsPotentialValues) {
        const result = [];
        for (const [option, values] of optionsPotentialValues) {
            if (this.referenceIdentical.has(option)) {
                result.push([option, this.referenceIdentical.get(option)]);
            }
            else {
                result.push([option, values]);
            }
        }
        return result;
    }
    buildOptionPropertiesSchema(variation) {
        const lookupIds = !Array.isArray(variation) ? [variation] : variation;
        const map = new Map();
        for (const id of lookupIds) {
            const lookup = this.resolutionSchema.safelyGetLookupById(id);
            const option = lookup.option;
            let property;
            if (singlePropertyLookupTypeGuard(lookup)) {
                property = lookup.property;
            }
            else if (extendedSinglePropertyLookupTypeGuard(lookup)) {
                property = lookup.properties[lookup.key];
            }
            else {
                throw new Error(`Lookup ${lookup.id} is not supported in variation`);
            }
            let set = map.get(lookup.option);
            if (!set) {
                set = new Set();
                map.set(option, set);
            }
            set.add(property);
        }
        const result = [];
        for (let [option, set] of map) {
            result.push({
                option,
                properties: Array.from(set)
            });
        }
        return result;
    }
    referenceEqualsExceptProperties(optionValues, properties, optionReference) {
        const result = [];
        for (const optionValue of optionValues) {
            if (this.optionSatisfies(optionValue, optionReference, properties)) {
                result.push(optionValue);
            }
        }
        return result;
    }
    replaceOptionGroup(result, option, optionValues) {
        for (let entry of result) {
            if (entry[0] === option) {
                entry[1] = optionValues;
                return;
            }
        }
    }
    optionSatisfies(optionValue, optionReference, unEqualProperties) {
        const unEqualSet = new Set(unEqualProperties);
        for (const [property, referenceValue] of Object.entries(optionReference)) {
            const optionPropertyValue = engineUtils.getPropertyPathValue(optionValue.model, property);
            const equals = engineUtils.equals(optionPropertyValue, referenceValue);
            if (unEqualSet.has(property)) {
                if (equals) {
                    return false;
                }
            }
            else {
                if (!equals) {
                    return false;
                }
            }
        }
        return true;
    }
    getVariationOptions() {
        return new Set(this.reference.keys());
    }
    variantsWithOptions(variation, options) {
        return this.resolutionSchema.getVariationLookups(variation)
            .filter(lookup => options.has(lookup.option))
            .map(lookup => lookup.id);
    }
}
//# sourceMappingURL=ExplicitResolutionStrategy.js.map